import { convertFromHTML, ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

export const convertHtmlToDraftContent = (html: string) => {
    const blocksFromHtml = convertFromHTML(html);
    const contentState = ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
        blocksFromHtml.entityMap
    );

    return EditorState.createWithContent(contentState);
};

export const convertDraftContentToHTML = (editorState: EditorState) => {
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const html = draftToHtml(rawContentState);

    return html.trim();
};

export const convertDraftContentToPlainText = (editorState: EditorState) => {
    return editorState.getCurrentContent().getPlainText();
};
